// extracted by mini-css-extract-plugin
export default {"BynameEntry":"Byname_BynameEntry__1Yara","ByamlFullEntry":"Byname_ByamlFullEntry__IlkNA"};